import React from "react";
import classes from "./Modal.module.css";
import ReactDOM from "react-dom";

// import ReactDOM from "react-dom";

const Backdrop = (props) => <div className={classes.backdrop} onClick={props.onClose}></div>;

const ModalOverlay = (props) => {
  return (
    <div className={classes.modal}>
      <div className={classes.content}>{props.children}</div>
    </div>
  );
};

const elementOverlay = document.getElementById("overlay--root");

const Modal = (props) => {
  return (
    <>
      {ReactDOM.createPortal(<Backdrop onClose={props.onClose} />, elementOverlay)}
      {ReactDOM.createPortal(<ModalOverlay>{props.children}</ModalOverlay>, elementOverlay)}
    </>
  );
};

export default Modal;
